import React from 'react';
import { connect } from 'react-redux';
import Selector from '../../util/Selector';
import { AUTH_LEVELS } from '../../../redux/constants/roles';

const GenericSelector = ({ roles, selected, onChange, disabled = false }) => (
  <Selector
    options={roles.map((role) => ({
      id: role.id,
      key: `${role.id}`,
      display: `${role.name} - ${role.description}`,
    }))}
    disabled={disabled}
    selected={selected}
    onChange={onChange}
  />
);

export const RoleTypeSelector = connect(({ user: { userAuthLevel }, users: { roleTypes } }) => ({
  roles: (userAuthLevel === AUTH_LEVELS.SUPER_ADMIN
    ? roleTypes
    : roleTypes.filter((rt) =>
        [AUTH_LEVELS.ADMIN, AUTH_LEVELS.USER, AUTH_LEVELS.NO_PORTAL_ACCESS].includes(rt.level)
      )
  ).toSorted((a, b) => a.level - b.level),
}))(GenericSelector);

class RoleSelectorUnconnected extends React.PureComponent {
  componentDidMount() {
    // If there's only one role available, auto-select it when creating a new user
    const { roles, selected, onChange } = this.props;
    if (roles?.length === 1 && !selected && onChange) {
      onChange({ target: { value: roles[0].id } });
    }
  }

  render() {
    const { roles, selected, onChange } = this.props;
    return <GenericSelector roles={roles} selected={selected} onChange={onChange} />;
  }
}

export const RoleSelector = connect(({ users: { roles }, user: { orgId } }) => ({
  roles: roles.filter((r) => r.global_visibility || r.org_id === orgId),
}))(RoleSelectorUnconnected);
